module.exports = __webpack_public_path__ + "img/20190613194934.bfeee191.jpg";